import { configureStore } from '@reduxjs/toolkit';
import userReducer from './slice/user';
import companyDataReducer from './slice/companyData';
import permissionSettingsReducer from './slice/permissionSettings';
import navigateReducer from './slice/navigate';
import workspaceRuducer from './slice/workspace';
import workspaceStatesRuducer from './slice/workspaceStates';
import enterpriseReducer from './slice/enterpriseLists';
import workspaceListReducer from './slice/workspaceList';

import menuReducer from './slice/manager/menu';
import paymentReducer from './slice/manager/payment';
import plansReducer from './slice/manager/plans';
import enterpriseCompanyReducer from './slice/manager/enterpriseCompany';
import invoicesReducer from './slice/manager/invoices';
import inquiryReducer from './slice/manager/inquiry';
import customizedOrderReducer from './slice/manager/customizedOrder';
import personalSubscriptionReducer from './slice/manager/personalSubscription';
import askReducer from './slice/tdp/ask';
import dashboardReducer from './slice/tdp/dashboard';

import lifeCycleReducer from './slice/lifeCycle';
import multilingualReducer from './slice/language/multilingual';
import industriesReducer from './slice/language/industries';
import blueprintReducer from './slice/tdp/blueprint';

const store = configureStore({
  reducer: {
    user: userReducer,
    companyData: companyDataReducer,
    permissionSettings: permissionSettingsReducer,
    navigate: navigateReducer,
    workspace: workspaceRuducer,
    workspaceStates: workspaceStatesRuducer,
    enterpriseLists: enterpriseReducer,
    workspaceList: workspaceListReducer,

    lifeCycle: lifeCycleReducer,

    menu: menuReducer,
    payment: paymentReducer,
    plans: plansReducer,
    enterpriseCompany: enterpriseCompanyReducer,
    invoices: invoicesReducer,
    inquiry: inquiryReducer,
    customizedOrder: customizedOrderReducer,
    personalSubscription: personalSubscriptionReducer,
    ask: askReducer,
    dashboard: dashboardReducer,

    multilingual: multilingualReducer,
    industries: industriesReducer,
    blueprint: blueprintReducer,
  },
});

export default store;
